import { css } from '@emotion/react';
import { IColors, Row, Tooltip } from '@bondsports/utils';
import { useWindowSize } from 'hooks/useWindowSize';
import { useColors } from 'hooks/useColors';
import InfoIcon from '@material-ui/icons/Info';
import { setOpacity } from 'styles/utils';

const registrationTypeTitleCss = (colors: IColors) => css`
  font-size: 1.4rem;
  font-weight: 600;
  line-height: 1.57;
  color: ${setOpacity(colors.tx_text_primary || '', 0.37)};
  padding-left: 10px;
  padding-top: 10px;
}
`;

const infoIconCss = (colors: IColors) => css`
	font-style: italic;
	vertical-align: text-top;
	color: ${setOpacity(colors.tx_text_primary || '', 0.37)};
`;

interface Props {
	title: string;
}

const RegistrationTitle = ({ title }: Props) => {
	const { isMobile } = useWindowSize();
	const { colors } = useColors();

	return (
		<Row align="baseline">
			<div css={registrationTypeTitleCss(colors)}>{title}</div>
			<Tooltip
				placement="right-end"
				content={'Price may vary based on package selected. Price shown is the starting value.'}
				isMobile={isMobile}
			>
				<InfoIcon color="inherit" fontSize="inherit" css={infoIconCss} />
			</Tooltip>
		</Row>
	);
};

export default RegistrationTitle;
